import PropTypes from 'prop-types';
import { SelectSearch } from 'mol-ui';
import { optionActions } from 'core/Option';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import {
    useDispatch,
    useSelector
} from 'hooks';

const VaccineDosePicker = ({
    disabled,
    fontSize = '12px',
    hasError,
    height,
    margin = '0px 0px 10px 0px',
    onChange,
    vaccine,
    value,
    width = '100%'
}) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const {
        vaccineDoses,
        vaccineDosesLoading: loading
    } = useSelector('option');

    useEffect(() => {
        if (!vaccine) {
            dispatch(optionActions.setOptionVaccineDoses([]));
            return;
        }
        dispatch(optionActions.getVaccineDoses(vaccine));
    }, [vaccine]);

    const selectProps = {
        fontSize,
        hasError,
        height,
        margin,
        onChange,
        value,
        width
    };

    return (
        <SelectSearch
            { ...selectProps }
            disabled={ disabled || loading }
            options={ vaccineDoses }
            placeholder={ t('Seleccione una dosis') }
        />
    );
};

VaccineDosePicker.propTypes = {
    disabled: PropTypes.bool,
    fontSize: PropTypes.string,
    hasError: PropTypes.bool,
    height: PropTypes.string,
    margin: PropTypes.string,
    onChange: PropTypes.func,
    vaccine: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.string
};

export default VaccineDosePicker;
